export default function Services() {
  const services = [
    {
      title: 'Gestion locative longue durée',
      category: 'Location',
      image: 'https://public.readdy.ai/ai/img_res/c35c9e6456ffe4b6296e3c958f238292.jpg',
      features: [
        'Sélection rigoureuse des locataires',
        'Gestion des contrats et encaissements',
        'Suivi régulier et entretien du bien',
        'Reporting mensuel détaillé'
      ]
    },
    {
      title: 'Conciergerie & location courte durée',
      category: 'Conciergerie',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20villa%20bedroom%20prepared%20for%20guests%2C%20perfectly%20made%20bed%20with%20white%20linens%2C%20fresh%20flowers%20on%20nightstand%2C%20welcome%20amenities%2C%20spotless%20clean%20room%2C%20warm%20ambient%20lighting%2C%20premium%20hospitality%20service%2C%20professional%20hotel-style%20presentation%2C%20high-end%20property&width=800&height=450&seq=service-conciergerie-001&orientation=landscape',
      features: [
        'Accueil et gestion des voyageurs',
        'Ménage et préparation entre séjours',
        'Coordination des services additionnels',
        'Optimisation des revenus locatifs'
      ]
    },
    {
      title: 'Surveillance de résidences secondaires',
      category: 'Surveillance',
      image: 'https://readdy.ai/api/search-image?query=Professional%20African%20security%20guard%20in%20navy%20blue%20uniform%20with%20tablet%20inspecting%20modern%20luxury%20villa%20with%20swimming%20pool%2C%20checking%20property%20security%20systems%2C%20daytime%20outdoor%20inspection%2C%20contemporary%20architecture%20with%20glass%20doors%2C%20professional%20property%20surveillance%20service%2C%20detailed%20security%20checklist%2C%20premium%20residential%20protection&width=800&height=450&seq=service-surveillance-new-002&orientation=landscape',
      features: [
        'Visites hebdomadaires programmées',
        'Vérification complète des installations',
        'Maintenance préventive et réparations',
        'Photos et rapports après chaque visite'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 md:py-32 bg-[#FAFBFC]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-4">Nos Prestations</p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight max-w-3xl">
            Des services adaptés à vos besoins
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden group hover:-translate-y-2"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A3B5C]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-[#C9A961] text-white px-3 py-1 rounded-full text-xs font-semibold">
                    {service.category}
                  </span>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  {service.title}
                </h3>

                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <i className="ri-check-line text-[#C9A961] text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-600 text-base">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-[#1A3B5C] font-semibold flex items-center space-x-2 hover:space-x-3 transition-all duration-300 group/btn cursor-pointer whitespace-nowrap"
                >
                  <span>En savoir plus</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#C9A961]/10 to-[#1A3B5C]/10 p-8 md:p-12 rounded-2xl border border-[#C9A961]/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-[#C9A961] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-gift-line text-white text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#1A3B5C] mb-1">Offre de lancement</h3>
                <p className="text-gray-600 text-lg">Audit gratuit de l'état de votre bien</p>
              </div>
            </div>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-[#1A3B5C] text-white px-8 py-4 rounded-lg hover:bg-[#2A4B6C] transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Réserver mon audit gratuit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
